import { LayersIcon } from '../../../../../assets/icons/common';
import { useDispatch } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';

interface Props {
    isFetching: boolean;
    getNextQuestion: () => void;
}

export default function ExamBreak(props: Props) {
    const { getNextQuestion, isFetching } = props;
    const dispatch = useDispatch();
    const [counter, setCounter] = useState(600);

    useEffect(() => {
        const timer = setInterval(() => {
            setCounter(prev => {
                if (prev <= 0) {
                    clearInterval(timer);
                    getNextQuestion();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const minutes = Math.floor(counter / 60);
    const seconds = counter % 60;
    const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    return (
        <Modal
            size='md'
            icon={<LayersIcon />}
            title='Break Time - 10 Minutes'
            childClassName={styles.wrapper}
        >
            <h3>The next question will start automatically in {formattedTime} minutes.</h3>
            <p>If you don’t start the next question, you will lose your chance to answer.</p>
            <Button
                text='Start Next Question Now'
                onClick={getNextQuestion}
                loading={isFetching}
            />
        </Modal>
    )
}
